import { useQuery } from 'react-query';
import {
  getLeaderboard,
  getLeaderboardWinners,
  getUserLeaderboard,
} from './endpoints';
import { Id } from 'new/api/types';

export const useLeaderboard = () =>
  useQuery({
    queryKey: ['LEADERBOARD'],
    queryFn: () => getLeaderboard.endpoint().then((res) => res.data),
  });

export const useUserLeaderboard = (dentistInfoId?: Id) =>
  useQuery({
    queryKey: ['LEADERBOARD_USER'],
    queryFn: () =>
      getUserLeaderboard.endpoint({}, dentistInfoId).then((res) => res.data),
    enabled: !!dentistInfoId,
  });

export const useLeaderboardWinners = (month: number, year: number) =>
  useQuery({
    queryKey: [`LEADERBOARD_WINNERS_${month}_${year}`],
    queryFn: () =>
      getLeaderboardWinners
        .endpoint({
          month,
          year,
        })
        .then((res) => res.data),
  });
